var map = {
	"./angels.svg": "b525",
	"./astros.svg": "c306",
	"./athletics.svg": "4f94",
	"./blue-jays.svg": "ddb8",
	"./cubs.svg": "a11a",
	"./diamondbacks.svg": "c096",
	"./giants.svg": "34e4",
	"./guardians.svg": "3378",
	"./mariners.svg": "852d",
	"./mets.svg": "f59e",
	"./nationals.svg": "9e61",
	"./orioles.svg": "444a",
	"./padres.svg": "e1a3",
	"./pirates.svg": "d75d",
	"./rays.svg": "9f7d",
	"./red-sox.svg": "4e86",
	"./reds.svg": "8ccf",
	"./royals.svg": "4482",
	"./tigers.svg": "a813",
	"./twins.svg": "b2ac",
	"./white-sox.svg": "d56d",
	"./yankees.svg": "f54c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8ce9";